function setCSSVar(element, property, value) {
  const elem = element ? element : document.documentElement;
  elem.style.setProperty(property, value);
}

export default setCSSVar;